import type { PublicBlueprint } from "@shared/blueprint";

/** Identité du projet, figée au build depuis blueprint.json. */
export const blueprint: PublicBlueprint = __BLUEPRINT__;

export function moduleEnabled(name: string): boolean {
  return name in blueprint.modules;
}

export function moduleOptions<T>(name: string, fallback: T): T {
  return (blueprint.modules[name] as T | undefined) ?? fallback;
}
